<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
  },
  created() { },
  mounted() {
    //进来默认执行一遍
    let width = window.innerWidth;
    let scale = Math.min(width / 1920);
    document.getElementsByTagName("html")[0].style.fontSize = scale * 100 + 'px';
    // 监听浏览器窗口大小变化
    window.addEventListener('resize', () => {
      let width = window.innerWidth;
      let scale = Math.min(width / 1920);
      document.getElementsByTagName("html")[0].style.fontSize = scale * 100 + 'px';
    });
  },
};
</script>
